import { useState, useEffect } from 'react';   // ← useEffect added
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { placeOrder } from '../../services/api';

export default function Checkout() {
  const { cart, cartTotal, clearCart } = useCart();
  const [form, setForm] = useState({
    customer_name: '',
    phone: '',
    address: '',
    city: '',
    zip_code: '',
    notes: '',
  });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  // Meta Pixel – InitiateCheckout
  useEffect(() => {
    if (window.fbq && cart.length > 0) {
      window.fbq('track', 'InitiateCheckout', {
        content_ids: cart.map((item) => item.slug ),
        content_type: 'product',
        value: cartTotal,
        currency: 'ILS',
        num_items: cart.length,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!form.customer_name || !form.phone || !form.address) {
    setError('يرجى ملء جميع الحقول المطلوبة');
    return;
  }
  setSubmitting(true);
  setError('');
  
  try {
    const orderItems = cart.map((item) => ({
      id: item.slug,
      name: item.name,
      price: item.price,
      quantity: item.quantity,
    }));

    const data = await placeOrder({ ...form, items: orderItems });
    console.log('Order response:', data);
    
    // Success - clear cart
    clearCart();

    // Meta Pixel – Purchase
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: cartTotal,
        currency: 'ILS',
        content_ids: cart.map((item) => item.slug ),
        content_type: 'product',
      });
    }
    console.log('Purchase tracked:', data.order_id);
    const orderNumber = data.order_id || data.orderId || data.id;
if (!orderNumber) {
  throw new Error('لم يتم استلام رقم الطلب');
}


    // Redirect to tracking page with success
    navigate(
      `/track?order_id=${orderNumber}&phone=${encodeURIComponent(form.phone)}&success=true`
    );
  } catch (err) {
    console.error('Order error:', err);
    setError(err.message || 'حدث خطأ أثناء إرسال الطلب. الرجاء المحاولة مرة أخرى.');
  } finally {
    setSubmitting(false);
  }
};

  if (cart.length === 0) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <p className="text-white text-xl">السلة فارغة</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black py-12 px-4" dir="rtl">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-black text-white mb-8">
          إتمام الطلب (الدفع عند الاستلام)
        </h1>
        {error && (
          <div className="bg-red-900/50 text-red-300 p-3 rounded-lg mb-4">
            {error}
          </div>
        )}
        <form
          onSubmit={handleSubmit}
          className="bg-neutral-950 p-8 rounded-2xl shadow-xl border border-neutral-800 space-y-4"
        >
          <div>
            <label className="block text-neutral-300 font-semibold mb-1">
              الاسم الكامل *
            </label>
            <input
              name="customer_name"
              value={form.customer_name}
              onChange={handleChange}
              required
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white"
            />
          </div>
          <div>
            <label className="block text-neutral-300 font-semibold mb-1">
              رقم الهاتف *
            </label>
            <input
              name="phone"
              value={form.phone}
              onChange={handleChange}
              required
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white"
            />
          </div>
          <div>
            <label className="block text-neutral-300 font-semibold mb-1">
              العنوان *
            </label>
            <input
              name="address"
              value={form.address}
              onChange={handleChange}
              required
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-neutral-300 font-semibold mb-1">
                المدينة
              </label>
              <input
                name="city"
                value={form.city}
                onChange={handleChange}
                className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white"
              />
            </div>
            <div>
              <label className="block text-neutral-300 font-semibold mb-1">
                الرمز البريدي
              </label>
              <input
                name="zip_code"
                value={form.zip_code}
                onChange={handleChange}
                className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white"
              />
            </div>
          </div>
          <div className="border-t border-neutral-800 pt-4">
            <h2 className="text-xl font-bold text-white mb-4">ملخص الطلب</h2>
            {cart.map((item) => (
              <div
                key={item.slug}
                className="flex justify-between text-white mb-2"
              >
                <span>
                  {item.name} x {item.quantity}
                </span>
                <span>{item.price * item.quantity} شيكل</span>
              </div>
            ))}
          </div>
          <div>
            <label className="block text-neutral-300 font-semibold mb-1">
              ملاحظات
            </label>
            <textarea
              name="notes"
              value={form.notes}
              onChange={handleChange}
              className="w-full p-3 bg-neutral-900 border border-neutral-700 rounded-lg text-white"
            />
          </div>
          <div className="border-t border-neutral-800 pt-4">
            <p className="text-xl font-bold text-white">
              المجموع: {cartTotal} شيكل
            </p>
            <button
              type="submit"
              disabled={submitting}
              className="mt-4 bg-red-600 text-white w-full py-4 font-bold rounded-xl hover:bg-red-700 disabled:bg-neutral-700 transition"
            >
              {submitting ? 'جاري إرسال الطلب...' : 'تأكيد الطلب'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}